import { BasketModel } from './basket.model';
import { CustomerModel } from './customer.model';

export interface OrderModel {
  customer: CustomerModel;
  currency: string;
  basket: BasketModel;
  stripePaymentMethodId?: string;
}

export enum OrderResponseStatus {
  Undefined = 0,
  Succeeded = 1,
  PaymentFailed = 2,
  NoAvailability = 3,
}

export interface OrderResultModel {
  status?: OrderResponseStatus;
  error?: Error;
}

export interface PaynetOrderResultModel extends OrderResultModel {
  paynetPaymentId: number;
  paynetSignature: string;
}

export interface StripeOrderResultModel extends OrderResultModel {
  paymentIntent: StripePaymentIntent;
}

export interface StripePaymentIntent {
  status: PaymentTransactionStatusType;
  clientSecret?: string;
  stripePaymentMethodId: string;
  stripeConnectedAccountId: string;
}

export enum PaymentTransactionStatusType {
  ReadyForPayment = 1,
  RequiresAction = 2,
  RequiresCapture = 3,
  Succeeded = 4,
  Failed = 5,
}

export interface InvalidBasketResultModel extends OrderResultModel {
  invalidOptionIds: number[];
}
